module.exports = __webpack_public_path__ + "assets/img/ja-c5580a5f.png";